<template>
  <section id="faq">
    <v-card
      flat
      class="faq-bg d-flex align-center justify-center text-center mb-9"
    >
      <v-card-text>
        <p class="faq-nome text-2xl font-weight-semibold primary--text mb-2">
          Olá, como podemos ajudar?
        </p>

        <p>ou escolha uma categoria para encontrar rapidamente a ajuda de que precisa</p>

        <v-form class="faq-search-input mx-auto">
          <v-text-field
            v-model="knowledgeBaseSearchQuery"
            outlined
            placeholder="Pesquisar...."
            hide-details
            class="faq-search-input"
          >
            <template #prepend-inner>
              <v-icon
                size="23"
                class="mx-1"
              >
                {{ icons.mdiMagnify }}
              </v-icon>
            </template>
          </v-text-field>
        </v-form>
      </v-card-text>
    </v-card>

    <div class="d-flex justify-end mb-6 bg-surface-variant">
      <v-btn
        v-if="functionalityAdd"
        color="success"
        class="ma-2 pa-2"
        @click="openDialog"
      >
        Adicionar <v-icon size="22">
          {{ icons.mdiPlus }}
        </v-icon>
      </v-btn>
    </div>

    <v-card-text class="perguntasERespostas-section">
      <v-row>
        <v-col
          v-for="item in filterFaqData"
          :key="item.nome"
          md="10"
          offset-md="2"
          cols="12"
          class="mx-auto mb-8"
        >
          <div class="faq-nome d-flex align-center">
            <v-avatar
              color="secondary"
              rounded
              size="40"
              class="v-avatar-light-bg"
            >
              <v-icon
                size="24"
                class="text--primary"
              >
                {{ icons.mdiAlertCircleOutline }}
              </v-icon>
            </v-avatar>

            <div class="ms-4">
              <h2 class="text--primary text-xl font-weight-medium">
                {{ item.nome }}
              </h2>

              <p class="mb-0">
                {{ item.descricao }}
              </p>
            </div>

            <v-icon
              v-if="functionalityEdit"
              class="mx-2"
              @click="editFaq(item)"
            >
              {{ icons.mdiPencil }}
            </v-icon>

            <v-icon
              v-if="functionalitydelete"
              @click="deleteFaq(item.id)"
            >
              {{ icons.mdiDelete }}
            </v-icon>

            <v-icon
              v-if="funcQuestionAdd"
              class="mx-2"
              @click="addQuestion(item)"
            >
              {{ icons.mdiPlusBox }}
            </v-icon>
          </div>

          <div class="faq-perguntasERespostas-respostas mt-6">
            <v-expansion-panels>
              <v-expansion-panel
                v-for="data in item.perguntasERespostas"
                :key="data.perguntasERespostas"
              >
                <v-expansion-panel-header class="text-base">
                  {{ data.pergunta }}

                  <div class="d-flex justify-end mx-4">
                    <v-icon
                      v-if="funcQuestionDelete"
                      class="mx-2"
                      @click="deleteQuestion(data)"
                    >
                      {{ icons.mdiDelete }}
                    </v-icon>

                    <v-icon
                      v-if="funcQuestionEdit"
                      @click="editQuestion(data)"
                    >
                      {{ icons.mdiPencil }}
                    </v-icon>
                  </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div
                    class="resposta"
                    v-html="data.resposta"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-col>

        <!-- no result found -->
        <v-col
          v-show="!filterFaqData.length"
          cols="12"
          class="text-center"
        >
          <h4 class="mt-4">
            Resultado da pesquisa não encontrado!
          </h4>
        </v-col>
      </v-row>
    </v-card-text>

    <!-- <v-card-text class="text-center">
      <p class="text-xl font-weight-medium text--primary mb-1">Você ainda tem uma pergunta?</p>
      <p>
        Se você não encontrar uma pergunta em nosso FAQ, você sempre pode entrar em contato conosco. Em breve lhe
        responderemos!
      </p>
    </v-card-text>

    <v-row class="mx-auto">
      <v-col
        v-for="(contact, index) in contactDetails"
        :key="contact.icon"
        cols="12"
        sm="6"
        md="5"
        :class="index > 0 ? 'me-auto' : 'ms-auto'"
      >
        <v-card class="faq-contact text-center pa-5" flat>
          <v-avatar rounded color="secondary" size="38" class="v-avatar-light-bg mb-6">
            <v-icon class="text--primary" size="24">
              {{ contact.icon }}
            </v-icon>
          </v-avatar>

          <p class="text-xl text--primary font-weight-medium mb-2">
            {{ contact.contact }}
          </p>

          <p class="text-sm mb-0">
            {{ contact.tagLine }}
          </p>
        </v-card>
      </v-col>
    </v-row> -->

    <faq-add-new-topico
      :items="items"
      :edit.sync="edit"
      :is-info-dialog-open.sync="isInfoDialogOpen"
      @refetch-data="getFaq"
      @close-dialog="closeDialog"
    />

    <faq-add-new-pergunta
      :items="items"
      :edit.sync="edit"
      :is-info-dialog-open.sync="OpenNew"
      @refetch-data="getFaq"
      @close-dialog="closeQuestion"
    />

    <v-dialog
      v-model="openDelete"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Excluir
        </v-card-title>

        <v-card-text> Tem certeza que deseja excluir? </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeDelete"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="success"
            @click="confirmDelete"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secundary"
            />

            <span v-else>OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<style lang="scss">
@import '@core/preset/preset/pages/faq.scss';

.resposta img{
  width: 400px;
}
</style>

<script>
import { onMounted, ref, computed, watch } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiMagnify, mdiAlertCircleOutline, mdiPhone, mdiEmailOutline, mdiPencil, mdiDelete, mdiPlus, mdiPlusBox } from '@mdi/js'
import FaqAddNewTopico from '@/views/faq/FaqAddNewTopico.vue'
import FaqAddNewPergunta from '@/views/faq/FaqAddNewPergunta.vue'
import FaqService from '@/services/modules/FaqService'
import useAuthStore from '@/store/auth'

export default {
  components: {
    FaqAddNewTopico,
    FaqAddNewPergunta,
  },

  setup() {
    const { funcionalidades } = storeToRefs(useAuthStore())

    const knowledgeBaseSearchQuery = ref('')
    const isInfoDialogOpen = ref(false)
    const OpenNew = ref(false)
    const loading = ref(false)
    const openDelete = ref(false)
    const questionDelete = ref(false)
    const id = ref('')
    const dataQuestion = ref('')
    const functionalityAdd = ref(false)
    const functionalityEdit = ref(false)
    const functionalitydelete = ref(false)
    const funcQuestionAdd = ref(false)
    const funcQuestionEdit = ref(false)
    const funcQuestionDelete = ref(false)
    const items = ref({
      nome: '',
      descricao: '',
      perguntasERespostas: [
        {
          pergunta: '',
          resposta: '',
        },
      ],
    })

    const edit = ref(false)

    const faqBlank = ref({
      nome: '',
      descricao: '',
      perguntasERespostas: [
        {
          pergunta: '',
          resposta: '',
        },
      ],
    })

    const faqQuestions = ref([])

    const contactDetails = [
      {
        icon: mdiPhone,
        contact: '+ (810) 2548 2568',
        tagLine: 'Nós estamos sempre felizes em ajudar!',
      },
      {
        icon: mdiEmailOutline,
        contact: 'hello@help.com',
        tagLine: 'Melhor maneira de obter uma resposta mais rápida!',
      },
    ]

    const permissions = () => {
      const functionalityMapping = {
        2141: functionalityAdd,
        2142: functionalityEdit,
        2143: functionalitydelete,
        2146: funcQuestionAdd,
        2147: funcQuestionEdit,
        2148: funcQuestionDelete,
      }

      Object.entries(functionalityMapping).forEach(([funcionalidadeId, element]) => {
        // eslint-disable-next-line radix
        if (funcionalidades.value.includes(parseInt(funcionalidadeId))) {
          // eslint-disable-next-line no-param-reassign
          element.value = true
        }
      })
    }

    const filterFaqData = computed(() => {
      const knowledgeBaseSearchQueryLower = knowledgeBaseSearchQuery.value.toUpperCase()

      return faqQuestions.value.filter(
        item => item.nome.toUpperCase().includes(knowledgeBaseSearchQueryLower)
          || item.perguntasERespostas.filter(queObj => queObj.pergunta.toUpperCase().includes(knowledgeBaseSearchQueryLower)).length
          || item.perguntasERespostas.filter(queObj => queObj.resposta.toUpperCase().includes(knowledgeBaseSearchQueryLower)).length,
      )
    })

    const getFaq = async () => {
      try {
        const data = await FaqService.getTopicos()
        permissions()
        faqQuestions.value = data
      } catch (err) {
        console.error('Erro', err)
      }
    }

    onMounted(getFaq)

    const deleteFaq = item => {
      openDelete.value = true
      id.value = item
    }

    const deleteQuestion = item => {
      openDelete.value = true
      id.value = item
      questionDelete.value = true
      dataQuestion.value = {
        id: item.id,
        topicoId: item.topicoId,
      }
    }

    const closeDelete = () => {
      openDelete.value = false
      questionDelete.value = false
      id.value = ''
    }

    const openDialog = () => {
      isInfoDialogOpen.value = true
    }

    const closeDialog = item => {
      edit.value = item
      isInfoDialogOpen.value = item
    }

    const closeQuestion = item => {
      edit.value = item
      OpenNew.value = item
    }

    const editFaq = item => {
      isInfoDialogOpen.value = true
      edit.value = true
      items.value = item
    }

    const editQuestion = item => {
      OpenNew.value = true
      edit.value = true
      items.value = item
    }

    const addQuestion = item => {
      OpenNew.value = true
      items.value = item
    }

    const confirmDelete = async () => {
      try {
        loading.value = true

        if (questionDelete.value) {
          await FaqService.deletarPerguntaResposta({ data: dataQuestion.value })
        } else {
          await FaqService.deletarTopico({ data: { id: id.value } })
        }

        closeDelete()
        loading.value = false
        getFaq()
      } catch (error) {
        loading.value = false
      }
    }

    watch(
      () => OpenNew.value,
      () => {
        if (!OpenNew.value) {
          edit.value = false
          items.value = JSON.parse(JSON.stringify(faqBlank.value))
        }
      },
    )

    watch(
      () => isInfoDialogOpen.value,
      () => {
        if (!isInfoDialogOpen.value) {
          edit.value = false
          items.value = JSON.parse(JSON.stringify(faqBlank.value))
        }
      },
    )

    return {
      closeDialog,
      openDialog,
      getFaq,
      editFaq,
      deleteFaq,
      confirmDelete,
      deleteQuestion,
      closeDelete,
      editQuestion,
      closeQuestion,
      addQuestion,
      permissions,
      functionalityAdd,
      functionalityEdit,
      functionalitydelete,
      funcQuestionAdd,
      funcQuestionEdit,
      funcQuestionDelete,
      dataQuestion,
      OpenNew,
      loading,
      openDelete,
      questionDelete,
      faqBlank,
      edit,
      items,
      isInfoDialogOpen,
      knowledgeBaseSearchQuery,
      filterFaqData,
      contactDetails,
      icons: {
        mdiMagnify,
        mdiAlertCircleOutline,
        mdiPencil,
        mdiDelete,
        mdiPlus,
        mdiPlusBox,
      },
    }
  },
}
</script>
